import React from 'react';

import './src/css/style.css';
import './src/css/global.css';
import { AppProvider } from './src/context/app';

export const wrapRootElement = ({ element }) => <AppProvider>{element}</AppProvider>;
